import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['overlay', 'message']

  show({ params }) {
    window.toastr?.clear()

    this.messageTarget.textContent = params.message || 'Processing...'
    this.overlayTarget.classList.remove('hidden')
    this.overlayTarget.classList.add('flex')
  }

  hide() {
    this.overlayTarget.classList.add('hidden')
    this.overlayTarget.classList.remove('flex')
  }
}
